import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'direction', 'Direction', [["path",{"d":"M9 10l3 -3l3 3","key":"svg-0"}],["path",{"d":"M9 14l3 3l3 -3","key":"svg-1"}]]);